// extracted by mini-css-extract-plugin
export default {"greenBadge":"campaign_greenBadge__Rkt9z","infoBadge":"campaign_infoBadge__iRrj-","dangerBadge":"campaign_dangerBadge__u5ah5","optionsModal":"campaign_optionsModal__QmHI8"};